module.exports = __webpack_public_path__ + "img/small-program-checked.c19763fd.png";